import { lazy } from 'react'

export const PRELOAD_RELOAD_KEY = 'minicar:preload-reload'

export function lazyWithReload(importFn) {
  return lazy(() =>
    importFn().then(
      (mod) => {
        if (!mod?.default) {
          if (!sessionStorage.getItem(PRELOAD_RELOAD_KEY)) {
            sessionStorage.setItem(PRELOAD_RELOAD_KEY, '1')
            window.location.reload()
          }
          throw new Error('lazy: no default export')
        }
        return mod
      },
      (err) => {
        if (!sessionStorage.getItem(PRELOAD_RELOAD_KEY)) {
          sessionStorage.setItem(PRELOAD_RELOAD_KEY, '1')
          window.location.reload()
        }
        throw err
      }
    )
  )
}
